module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"current_reward":"当前奖励","remaining_reward":"剩余可获得奖励"}}')
  delete Component.options._Ctor
}
